import { motion } from "framer-motion";
import { FEATURES } from "../../data/content";
import { Rise } from "./Reveal";

export const Showcase = () => {
  return (
    <section
      id="platform"
      data-testid="platform-section"
      className="border-t border-border bg-card/30 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <Rise className="mb-16 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="font-mono-ui text-[11px] font-bold uppercase tracking-[0.2em] text-primary">
              The Platform
            </span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.02]">
              One AI testing ecosystem. Every surface covered.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
            Web, mobile, API, desktop, database and TV — authored in plain English, executed on
            real devices, healed by AI.
          </p>
        </Rise>

        <div className="space-y-6">
          {FEATURES.map((f, i) => {
            const flip = i % 2 === 1;
            return (
              <Rise
                key={i}
                delay={0.05}
                className={`group grid items-stretch gap-6 lg:grid-cols-2 ${
                  flip ? "" : ""
                }`}
              >
                {/* Text block */}
                <div
                  className={`flex flex-col justify-center rounded-2xl border border-border bg-card p-8 lg:p-12 ${
                    flip ? "lg:order-2" : ""
                  }`}
                >
                  <span className="font-mono-ui text-[11px] font-bold uppercase tracking-[0.2em] text-primary">
                    {f.tag}
                  </span>
                  <h3 className="mt-4 font-heading text-2xl lg:text-3xl font-medium tracking-tight">
                    {f.title}
                  </h3>
                  <p className="mt-4 max-w-md text-base leading-relaxed text-muted-foreground">
                    {f.body}
                  </p>
                </div>

                {/* Image block, clipped + spotlight */}
                <div
                  className={`relative overflow-hidden rounded-2xl border border-border bg-black ${
                    flip ? "lg:order-1" : ""
                  }`}
                >
                  <div className="absolute inset-0 z-10 bg-[radial-gradient(400px_circle_at_50%_0%,hsla(39,47%,60%,0.18),transparent_70%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  <motion.img
                    src={f.image}
                    alt={f.title}
                    loading="lazy"
                    decoding="async"
                    className="h-64 w-full object-cover opacity-80 transition-[transform,opacity] duration-700 group-hover:scale-105 group-hover:opacity-100 lg:h-full min-h-[280px]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                </div>
              </Rise>
            );
          })}
        </div>
      </div>
    </section>
  );
};
